import { render, staticRenderFns } from "./docx.vue?vue&type=template&id=61d65a9f"
import script from "./docx.vue?vue&type=script&lang=js"
export * from "./docx.vue?vue&type=script&lang=js"
import style0 from "./docx.vue?vue&type=style&index=0&id=61d65a9f&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports